<template>
  <div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
    <div class="kt-subheader   kt-grid__item">
      <div class="kt-container  kt-container--fluid ">
        <div class="kt-subheader__main">
          <h3 class="kt-subheader__title">
            Project
          </h3>
          <span class="kt-subheader__separator kt-hidden" />
          <div class="kt-subheader__breadcrumbs">
            <router-link to="/" class="kt-subheader__breadcrumbs-home">
              <i
                class="flaticon2-shelter"
                @click="trackCustomEvent({ action: 'clicked', target: 'breadcrumbs_content', linkTo: 'overview' })"
              />
            </router-link>
            <span class="kt-subheader__breadcrumbs-separator" />
            <span class="kt-subheader__breadcrumbs-link kt-subheader__breadcrumbs-link--active">Project</span>
          </div>
        </div>
      </div>
    </div>

    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
      <div class="kt-portlet">
        <div class="kt-portlet__body">
          <LoadingSpinner v-if="!isLoaded" />
          <Projectcomponent v-else :project-detail-state="projectDetailState" />
        </div>
      </div>

      <!-- <div class="row">
        <div class="col-xl-12">
          <div class="kt-portlet kt-portlet--height-fluid">
            <div class="kt-portlet__head">
              <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title">
                  Request Count
                </h3>
              </div>
            </div>
            <div class="kt-portlet__body">
              <LoadingSpinner v-if="!isLoaded" />
              <div v-else-if="projectRequestLineChartData" class="row">
                <div class="col-9">
                  <div class="kt-widget16__items">
                    <div class="kt-portlet__body kt-portlet__body--fluid justify-content-center">
                      <ProjecrRequestLinechart :chart-data="projectRequestLineChartData" />
                    </div>
                  </div>
                </div>
                <div class="col-3 d-flex align-items-center">
                  <ProjectRequestTable :project-total="projectRequestLineChartData" />
                </div>
              </div>
              <div v-else class="d-flex flex-column justify-content-center align-items-center kt-label-font-color-1" style="height:200px;">
                <ChartIcon />
                <h5><span>No Data Available</span></h5>
                <p>Try selecting a different time period.</p>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <div v-if="projectDetailState.tokens !== null && projectDetailState.services !== null" class="kt-align-right kt-margin-b-10">
        <DatePicker
          v-model="dateRange"
          @input="trackCustomEvent({ event: 'input', action: 'selected', target: 'calendar_content', value: dateRange }); updateRange($event)"
        />
      </div>

      <div v-if="projectDetailState.tokens !== null && projectDetailState.services !== null" class="row">
        <div class="col-xl-8">
          <div class="kt-portlet kt-portlet--height-fluid">
            <div class="kt-portlet__head">
              <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title">
                  Request Count
                </h3>
              </div>
            </div>
            <div class="kt-portlet__body d-flex flex-column justify-content-center">
              <LoadingSpinner v-if="!isLoaded" />
              <div v-else-if="projectRequestLineChartData">
                <ProjectRequestLinechart :chart-data="projectRequestLineChartData" />
              </div>
              <div v-else class="d-flex flex-column align-items-center kt-label-font-color-1" style="height: 200px ">
                <ChartIcon />
                <h5><span>No Data Available</span></h5>
                <p>Try selecting a different time period.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4">
          <div class="kt-portlet kt-portlet--height-fluid">
            <div class="kt-portlet__head">
              <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title">
                  Total
                </h3>
              </div>
            </div>
            <div class="kt-portlet__body d-flex flex-column justify-content-center">
              <LoadingSpinner v-if="!isLoaded" />
              <div v-else-if="projectRequestLineChartData">
                <ProjectRequestTable :project-total="projectRequestLineChartData" />
              </div>
              <div v-else class="d-flex flex-column align-items-center kt-label-font-color-1" style="height:200px;">
                <ChartIcon />
                <h5><span>No Data Available</span></h5>
                <p>Try selecting a different time period.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="projectDetailState.tokens !== null && projectDetailState.services !== null" class="row">
        <div class="col-xl-12">
          <div class="kt-portlet kt-portlet--height-fluid">
            <div class="kt-portlet__head">
              <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title">
                  Response Time
                </h3>
              </div>
            </div>
            <div class="kt-portlet__body d-flex flex-column justify-content-center">
              <LoadingSpinner v-if="!isLoaded" />
              <div v-else-if="projectResponseLineChartData">
                <ProjectResponseLinechart :chart-data="projectResponseLineChartData" />
              </div>
              <div v-else class="d-flex flex-column align-items-center kt-label-font-color-1" style="height: 200px">
                <ChartIcon />
                <h5><span>No Data Available</span></h5>
                <p>Try selecting a different time period.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="projectDetailState.tokens === null && projectDetailState.services === null" class="row">
        <div class="col-xl-12">
          <div class="kt-portlet kt-portlet--height-fluid">
            <div class="kt-portlet__body d-flex flex-column" style="height: 400px">
              <LoadingSpinner v-if="!isLoaded" />
              <div v-else class="d-flex flex-column align-items-center justify-content-center kt-margin-t-40">
                <TokenIcon />
                <h5><span>Empty project</span></h5>
                <!-- <p>Go to <strong><router-link :to="`/credential/${projectId}`" style="color: #704fff">Credential</router-link></strong> page to create token for </p> -->
                <p>To start using NLP services, create a token and attach services to it.</p>
                <router-link :to="`/credential/${projectId}`" style="color: #704fff">
                  <button
                    class="btn btn-brand btn-icon-sm"
                    @click="trackCustomEvent({ action: 'clicked', target: 'button_content', linkTo: 'credential' })"
                  >
                    Go to Credential page
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-else class="kt-portlet__body kt-portlet__body--fit">
      <div class="row">
        <div class="col-xl-12">
          <div class="kt-portlet kt-portlet--height-fluid">
            <div class="kt-portlet__body d-flex flex-column justify-content-center">
              <TokenIcon class="d-flex flex-column justify-content-center" />
              <h5><span>No Token</span></h5>
              <p>
                Go to
                <strong>
                  <router-link :to="`/credential/${projectId}`" style="color: #704fff">Credential</router-link>
                </strong>
                page to create your first classification token
              </p>
              <router-link :to="`/credential/${projectId}`" style="color: #704fff">
                <button class="btn btn-brand btn-icon-sm">
                  Create token
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DatePicker from '../components/Datepicker'
import Projectcomponent from '../components/ProjectDetail'
import moment from 'moment'
import ProjectRequestTable from '../components/ProjectRequestTable'
import ProjectRequestLinechart from '../components/ProjectRequestLinechart'
import ProjectResponseLinechart from '../components/ProjectResponseLinechart'
import LoadingSpinner from '../components/LoadingSpinner'
import ChartIcon from '../components/ChartIcon'
import TokenIcon from '../components/TokenIcon'

export default {
  // name: 'dashboard',
  components: {
    ProjectRequestTable,
    ProjectRequestLinechart,
    ProjectResponseLinechart,
    DatePicker,
    Projectcomponent,
    LoadingSpinner,
    ChartIcon,
    TokenIcon
  },
  data () {
    return {
      project: {
        detail: {},
        errorCount: 0
      },
      dateRange: {
        startDate: moment().subtract(7, 'd').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
      },
      selected: {
        start: moment().subtract(7, 'd').format('x'),
        stop: moment().format('x'),
        binSize: 0
      },
      projectRequestLineChartData: [],
      projectResponseLineChartData: [],
      isLoaded: false
    }
  },
  computed: {
    ...mapGetters({
      getProjectDetailState: 'project/getProjectDetailState'
    }),
    binSize () {
      const diffSec = (this.selected.stop - this.selected.start) / 1000
      const hour = 60 * 60
      const day = 24 * hour

      if (diffSec < 3 * day) {
        return hour
      } else {
        return day
      }
    },
    projectId () {
      return this.$route.params.projectId
    },
    projectDetailRequest () {
      return this.getProjectDetail(this.projectId)
    },
    projectErrorCount () {
      return this.getProjectErrorCount(this.projectId)
    },
    projectDetailState () {
      return this.getProjectDetailState[this.projectId]
    }
  },
  watch: {
    selected: {
      handler () {
        this.getProjectUsage()
        this.getProjectResponse()
      },
      deep: true
    },
    async $route () {
      this.isLoaded = false
      await this.projectDetailRequest
      await this.projectErrorCount
      await this.getProjectUsage()
      await this.getProjectResponse()
      this.isLoaded = true
    }
  },
  async mounted () {
    await this.projectDetailRequest
    await this.projectErrorCount
    await this.getProjectUsage()
    await this.getProjectResponse()
    this.isLoaded = true
  },
  methods: {
    ...mapActions({
      getProjectDetail: 'project/getProjectDetail',
      getProjectErrorCount: 'project/getProjectErrorCount',
      getProjectUsageRequest: 'project/getProjectUsage',
      getProjectResponseRequest: 'project/getProjectResponse',
      trackCustomEvent: 'user/trackCustomEvent'
    }),
    updateRange (values) {
      this.selected.start = moment(values.start).format('x')
      this.selected.stop = moment(values.end).format('x')
    },
    async getProjectUsage () {
      this.projectRequestLineChartData = await this.getProjectUsageRequest({
        projectId: this.projectId,
        start: Number(this.selected.start),
        stop: Number(this.selected.stop),
        binSize: this.binSize
      })
    },
    async getProjectResponse () {
      this.projectResponseLineChartData = await this.getProjectResponseRequest({
        projectId: this.projectId,
        start: Number(this.selected.start),
        stop: Number(this.selected.stop),
        binSize: this.binSize
      })
    }
  }
}
</script>

<style scoped>
.kt-subheader {
  margin-top: 0px;
}
</style>
